import { Container, Row, Col, Card, Alert, Button, Badge, ListGroup } from "react-bootstrap";
import { FaCoffee, FaUsers, FaShieldAlt, FaCode, FaPaypal, FaRoad, FaPaw, FaEnvelope } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import AppContext from "../context/app-context";
import LanguageSwitcher from "../components/LanguageSwitcher";
import { useContext } from "react";

const AboutUsPage = () => {
  const { t } = useTranslation();
  const { theme } = useContext(AppContext);

  return (
    <Container className="my-5">
      <h1 className="mb-4">
        {t("aboutUs.title")} <FaPaw className="text-success" />
      </h1>

      {/* Mission Section */}
      <Card className={`mb-4 ${theme === "dark" ? "bg-dark text-light" : ""}`}>
        <Card.Body>
          <h2 className="mb-3">
            <FaCode className="me-2" /> {t("aboutUs.mission.title")}
          </h2>
          <p>{t("aboutUs.mission.content")}</p>
        </Card.Body>
      </Card>

      {/* Story Section */}
      <Row className="mb-4">
        <Col md={6}>
          <h3>
            <FaUsers className="me-2" /> {t("aboutUs.story.title")}
          </h3>
          <p>{t("aboutUs.story.content")}</p>
        </Col>
        <Col md={6}>
          <Alert variant="info">
            <h4>
              <FaShieldAlt className="me-2" /> {t("aboutUs.trust.title")}
            </h4>
            <ListGroup variant="flush">
              <ListGroup.Item>{t("aboutUs.trust.point1")}</ListGroup.Item>
              <ListGroup.Item>{t("aboutUs.trust.point2")}</ListGroup.Item>
              <ListGroup.Item>{t("aboutUs.trust.point3")}</ListGroup.Item>
            </ListGroup>
          </Alert>
        </Col>
      </Row>

      {/* Team Section */}
      <Card className={`mb-4 ${theme === "dark" ? "bg-dark text-light" : ""}`}>
        <Card.Body>
          <h3>
            <FaUsers className="me-2" /> {t("aboutUs.team.title")}
          </h3>
          <p>{t("aboutUs.team.content")}</p>
          <div className="mt-3">
            <Button variant="outline-success" href="mailto:support@kokofin.com">
              <FaEnvelope className="me-2" /> {t("aboutUs.contactButton")}
            </Button>
          </div>
        </Card.Body>
      </Card>

      {/* Support Section */}
      <Alert variant="success" className="mb-4">
        <h3>
          <FaCoffee className="me-2" /> {t("aboutUs.support.title")}
        </h3>
        <p>{t("aboutUs.support.content")}</p>
        <Button variant="dark" href="https://www.paypal.com/ncp/payment/F4KK4RCLJH3SC" target="_blank" className="mt-2">
          <FaPaypal className="me-2" /> {t("aboutUs.donateButton")}
        </Button>
      </Alert>

      {/* Roadmap Section */}
      <div className="mb-4">
        <h3>
          <FaRoad className="me-2" /> {t("aboutUs.roadmap.title")}
        </h3>
        <ListGroup>
          {["export", "teams", "reminders"].map((item) => (
            <ListGroup.Item key={item}>
              <Badge bg="success" className="me-2">
                ✓
              </Badge>
              {t(`aboutUs.roadmap.${item}`)}
            </ListGroup.Item>
          ))}
        </ListGroup>
      </div>

      {/* Transparency Section */}
      <Alert variant="secondary">
        <h4>{t("aboutUs.transparency.title")}</h4>
        <p>{t("aboutUs.transparency.content")}</p>
      </Alert>
    </Container>
  );
};

export default AboutUsPage;
